import { clsx } from 'clsx';
import { externalUrls } from '../../../constants/urls';
import styles from './Footer.module.scss';
import { Link } from 'react-router-dom';

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  return (
    <footer className={clsx(styles.footer, className)}>
      <div className={styles.content}>
        <p className={styles.copyright}>
          © {new Date().getFullYear()} Volt Finance. Toate drepturile rezervate
        </p>

        <nav className={styles.links}>
          <a
            href={externalUrls.volt.home}
            className={styles.link}
            target="_blank"
          >
            Pagina principală
          </a>
          <Link
            to={externalUrls.volt.contact}
            className={styles.link}
            target="_blank"
          >
            Contact
          </Link>
          <Link
            to={externalUrls.volt.blog}
            className={styles.link}
            target="_blank"
          >
            Blog
          </Link>
        </nav>
      </div>
    </footer>
  );
}
